<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="detailDialogVisible"
        center
        class="detail-dialog-container"
        width="694px">
        <div class="dialog-container flex flex-direction ">
            <img class="header" src="../assets/img/icon_version_header.png">
            <div class="dialog-content flex flex-direction">
                <div class="dialog-operate flex align-center justify-end">
                    <i class="close el-icon-close margin-left-xs" @click="cancel(false)"></i>
                </div>
                <div class="title">{{ detail.title }}</div>
                <div class="content flex flex-direction">
                    <div v-html="detail.content"></div>
                    <div class="time self-end">{{ detail.add_time }}</div>
                </div>
            </div>
            <div class="dialog-footer">
                <img class="image" src="../assets/img/icon_version_bottom.png">
                <img class="baby" src="../assets/img/icon_version_baby.png">
            </div>

        </div>
    </el-dialog>
</template>

<script>
import {getVersionDetail} from '@/api/login'
import {zhDate} from '@/utils/utils'

export default {
    components: {},
    name: "VersionDetailDialog",
    props: {
        detailDialogVisible: {
            type: Boolean,
            default: false
        },
        nid: { //详情ID
            type: Number,
        },
    },
    data() {
        return {
            detail: '',
            applyDialogVisible: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.nid) this.init()
    },
    methods: {
        async init() {
            let _data = await getVersionDetail(this.nid)
            if (_data.status === 200) {
                _data.data.create_time = zhDate(_data.data.create_time * 1000)
                this.detail = _data.data[0]
            }
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        detailDialogVisible() {

        },
        nid() {
            if (this.nid) {
                this.detail = ''
                this.init()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        position: relative;
        .header{
            width: 100%;
            object-fit: fill;
            position: absolute;
        }


        .dialog-content {
            padding: 10px 20px;
            min-height: 505px;
            z-index: 2;

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .content {
                margin-top: 38px;
                padding: 30px;
                line-height: unset;
                overflow-y: scroll;
                height: 505px;
                &::-webkit-scrollbar {
                    background: transparent;
                    width: 5px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #0a224033;
                    height: 30px;
                }
            }


            .time {
                font-size: 16px;
                color: #0a2240;
                margin-top: 16px;
            }
        }

        .dialog-operate {

            .operate {
                width: 91px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                border: none;
                text-align: center;
                background-color: #ff9600;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
            }

            .close{
                font-size: 18px;
                color: #333333;
                cursor: pointer;
            }

        }

        .dialog-footer {
            position: relative;
            .image{
                width: 100%;
            }
            .baby{
                position: absolute;
                right: 50px;
                bottom: 10px;
                width: 108px;
            }
        }
    }
}
</style>
